import { useState } from "react";
import { api, err } from "../../lib/api";
import { Logo } from "../../components/laxmi/Chrome";

const IS_ADMIN = window.location.pathname.startsWith("/admin");

export default function Auth({ onLogin }) {
  const [register, setRegister] = useState(false), [phone, setPhone] = useState(""), [password, setPassword] = useState(""), [message, setMessage] = useState("");
  const submit = async e => {
    e.preventDefault();
    try {
      const r = await api.post(`/auth/${register ? "register" : "login"}`, { phone, password });
      localStorage.setItem("blueplay_token", r.data.token);
      onLogin(r.data);
    } catch (x) { setMessage(err(x)); }
  };
  return (
    <main className="auth-shell">
      <Logo /><button className="back-button" data-testid="auth-back-button">‹</button>
      <section className="auth-copy"><h1>{register ? "Register your phone" : IS_ADMIN ? "Admin login" : "Log in"}</h1><p>{register ? "Create your Laxmiwin account" : "Please log in with your phone number or email"}<br />If you forget your password, please contact customer service</p></section>
      <div className="auth-tabs">
        <button className={!register ? "selected" : ""} onClick={() => setRegister(false)} data-testid="phone-login-tab">▣ Phone Number</button>
        <button onClick={() => setRegister(true)} className={register ? "selected" : ""} data-testid="register-tab">✉ Register</button>
      </div>
      <form onSubmit={submit} className="auth-form">
        <label>▣ Phone number<input data-testid="phone-number-input" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Please enter the phone number" /></label>
        <label>▣ {register ? "Set password" : "Password"}<input data-testid="password-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" /></label>
        {register && <label>▣ Invite code<input data-testid="invite-code-input" value="358568030960" readOnly /></label>}
        <label className="check-row"><input type="checkbox" data-testid="remember-password-checkbox" /> Remember password</label>
        {message && <div className="error" data-testid="auth-error">{message}</div>}
        <button className="primary-button" data-testid="auth-submit-button">{register ? "Register" : "Log in"}</button>
        <button type="button" className="outline-button" onClick={() => setRegister(!register)} data-testid="auth-switch-button">{register ? "I have an account  Login" : "Register"}</button>
      </form>
    </main>
  );
}
